import React, { useEffect, useState } from 'react';
import { Alert, Card, Spinner } from 'react-bootstrap';
import { PageLayout } from '../../../../dorian-shared/types/pageLayout/PageLayout';
import { PromotionDetailResponse } from '../types/PromotionTypes';
import { api } from '../../../api';
import { ToolComponentProps } from '../../ToolPage/toolComponentProps';
import { PageWrapper } from '../../../ui/PageWrapper';
import { getPromotionsListUrl, getSubcategoryTitle } from '../utils/promotionUtils';

export function PromotionSubcategoryPage(props: ToolComponentProps) {
  const {
    auth, history, match, toolKey,
  } = props;
  const user = auth.getUser();
  const { id, subcategory } = match.params;
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');
  const [subcategoryTitle, setSubcategoryTitle] = useState(subcategory);
  const promotionUrl = `${getPromotionsListUrl(toolKey)}/${id}`;

  const pageLayout: PageLayout = {
    header: { title: 'Promotions' },
    sidebar: {
      nav: [
        {
          title: 'Back to promotion',
          action: () => history.push(promotionUrl),
          variant: 'secondary',
          disabled: false,
        },
      ],
    },
  };

  useEffect(() => {
    setLoading(true);
    api.get<PromotionDetailResponse>(`/v1/tools/promotions/${id}`)
      .then((response) => {
        setTitle(response.data.promotion.title);
        setSubcategoryTitle(getSubcategoryTitle(response.data.subcategories, subcategory));
      })
      .finally(() => setLoading(false));
  }, [id, subcategory]);

  return (
    <PageWrapper user={user} page={pageLayout}>
      <Card className="mt-3">
        <Card.Body>
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" size="sm" />
            </div>
          ) : (
            <>
              <Card.Title>
                {subcategoryTitle}
              </Card.Title>
              <Card.Subtitle className="mb-3 text-muted">
                {title}
              </Card.Subtitle>
              <Alert variant="info" className="mb-0">
                This subcategory editor is not implemented yet. The promotion shell, tags, and
                permissions are in place so configuration can be added here later.
              </Alert>
            </>
          )}
        </Card.Body>
      </Card>
    </PageWrapper>
  );
}
